export const environment = {
  production: true,
  // apiEndpoint: 'https://wealthgrowth.1q2ohf4dskqf.us-south.codeengine.appdomain.cloud/api/v1',
  // apiEndpoint: 'https://bupi2p4ibg.us-east-1.awsapprunner.com/api/v1',
  apiEndpoint: window.location.origin + '/api/v1',

  chat_apiEndpoint: 'wss://wealthgrowth.cognerium.com:8000', // chat api endpoint only works for aws server not for local server
};
